import { URL_DEFAULT } from '../config/config';

// // Listas de links que se muestran el la sideBar según la localización en el sistema
// // por ejemplo en las rutas del Array administración se muestra el encabezado y lista de administración
export const administracion = ['/usuarios'];
export const analista = [
  '/asignaciones',
  '/reclamos',
  '/pendientes',
  '/ayuda',
  '/buscador',
  '/derivaciones',
  '/gestionados',

];

export const analistaFichaTecnica = [
  '/ft-enviar',
  '/ft-ayuda',
  '/ft-directorio-del-prestador',
  '/fichas_tecnicas',
  '/ft-propuesta',
  '/ft-identificacion-prestador',
  '/ft-acreditacion',
  '/ft-representantes-encargados',
  '/ft-autorizacion-sanitaria',
  '/ft-dotacion-camas',
  '/ft-dotacion-camillas',
  '/ft-pabellones-qx',
  '/ft-salas-proc-sistema',
  '/ft-salas-por-tipo-proc',
  '/ft-imagenologia',
  '/ft-dotacion-personal',
  '/ft-equipamiento',
  '/ft-centro-medico',

  '/ft-laboratorio-clinico',

  '/ft-area-quimica-analitica',
  '/ft-area-hormonas',
  '/ft-area-microbiologia',
  '/ft-area-hematologia',
  '/ft-area-inmunodeficiencia',
  "/ft-area-hemostasia-y-trombosis",
  "/ft-sala-toma-de-muestra-externa",
  "/ft-area-inmunologia",
  "/ft-area-parasitologia",
  "/ft-area-serologia",
  "/ft-area-toxicologia",
  "/ft-area-citometria",
  "/ft-otro-laboratorio",



  '/ft-unidad-de-dialisis',


  '/ft-centro-de-esterilizacion',
  '/ft-central-de-esterilizacion',
  "/ft-area-de-preparacion",
  "/ft-area-de-almacenamiento-y-despacho",
  "/ft-area-de-recepcion-de-material-sucio",
  "/ft-area-de-lavado-y-descontaminacion",
  "/ft-area-de-esterilizacion",
  "/ft-area-de-secado-y-revision",


  '/ft-botiquin',
  "/ft-dispensacion-interna",
  "/ft-sala-reenvasado",
  "/ft-dispensacion-ambulatoria",



  '/ft-farmacia',
  "/ft-sala-de-fraccionamiento",
  "/ft-recetario-magistral",
  "/ft-unidad-de-preparados-oncologicos",
  "/ft-unidad-de-preparados-de-nutriciones-parenterales",
  "/ft-farmacia-interna",
  "/ft-farmacia-atencion-publico",
  "/ft-unidad-de-preparacion-de-mezclas-intravenosas",



  '/ft-pabellon-de-cirugia-menor-y-sala-procedimientos',

  '/ft-transporte-de-pacientes',
  "/ft-ambulancia-avanzada",
  "/ft-ambulancias-basicas",
  "/ft-ambulancia-medicalizada",


  '/ft-quimioterapia',

  '/ft-radioterapia',
  "/ft-sala-de-dosimetria-fisica",
  "/ft-sala-de-confeccion-de-bloques",
  "/ft-sala-de-braquiterapia",
  "/ft-sala-de-almacenaje-o-manipulacion-de-fuentes",
  "/ft-unidad-de-cobaltoterapia-convencionales",
  "/ft-unidad-de-acelerador-lineal-de-uso-medico-linac",
  "/ft-unidad-de-ortovoltaje",
  "/ft-salas-de-simulacion",
  "/ft-salas-de-planificacion-y-dosimetria-clinica",

  '/ft-odontologia',
  "/ft-salas-de-procedimiento-odontologico",
  "/ft-sala-de-imagenologia",
  "/ft-otros",
  "/ft-laboratorio-dental",


  '/ft-anatomia-patologica',
  "/ft-citologico",
  "/ft-histopatologia-diferida-o-corriente",
  "/ft-inmunohistoquimica",
  "/ft-biologia-molecular",
  "/ft-area-autopsia",
  "/ft-area-de-microscopia",
  "/ft-area-almacenamiento-de-cadaveres",
  "/ft-hstopatologia-intraoperatorio",



  '/ft-otros',
  '/ft-centro-de-rehabilitacion-de-alcohol-y-drogas',
  '/ft-recinto-para-el-desarrollo-de-medicina-complementarias',
  '/ft-establecimientos-de-atencion-primaria',
  '/ft-establecimiento--que-realizan-procuramientos-o-trasplantes-de-organos-y-tejidos',
  '/ft-sala-externa-de-toma-muestras',
  '/ft-sala-procedimiento-movil',
  '/ft-establecimiento-que-realizan-procuramientos-o-trasplantes-de-organos-y-tejidos',
  '/ft-unidades-de-medicina-transfuncional-utm',
  '/ft-unidades-de-medicina-transfuncional-umt',

  '/ft-medicina-nuclear',
  "/ft-dependencia-de-almacenamiento-de-equipos-de-gammagrafia",
  "/ft-sala-de-dosificacion-de-radioisotopos",
  "/ft-autorizacion-de-construccion-licencia",
  "/ft-bunker-para-operacion-de-equipos-de-gammagrafia-o-radiografia",
  "/ft-laboratorio-“caliente”-en-instalaciones-de-terapia,-mediante-medicina-nuclear-o-fraccionamiento-de-radioisotopos.",


  '/ft-laboratorio-dental',
  '/ft-servicio-privado-traslado-de-enfermos',
  '/ft-servicio-de-urgencia',
  '/ft-camillas',
  '/ft-unidad-de-pabellones',
  '/ft-pabellon-de-cirugia-menor',
  '/ft-consultas-profesionales',
  '/ft-box-de-atencion-o-consulta-con-examen-adulto',


  '/ft-centro-de-dialisis',

  '/ft-box/camilla',
  '/ft-camillas-de-recuperacion-de-anestesia-y/o-sedacion',
  '/ft-unidad-de-oncologia-y-alivio-del-dolor',
  '/ft-central-de-alimentacion-y-sedile',

  '/ft-camas',
  '/ft-camas-basicas',
  '/ft-cuidados-medios',
  '/ft-cuidados-criticos',

  '/ft-otras-camas',
  '/ft-salas-de-procedimientos',
  '/ft-salas-de-procedimientos-cardiologicos',
  '/ft-unidad-de-medicina-fisica-y-rehabilitacion',
  '/ft-unidades-donantes',
  '/ft-establecimientos-que-realizan-procuramientos-o-trasplantes-de-organos-y-tejidos',
  '/ft-centro-medico-y-o-diagnostico-salud',

  '/ft-camas-medicina',
  "/ft-camillas-recuperacion-anestesica-adulta",
  "/ft-camillas-recuperacion-anestesica-pediatrica",
  "/ft-camillas-recuperacion-cma",
  "/ft-otras-camillas",
  '/ft-unidad-de-recuperacion',

  '/ft-camas-cuidados-medios',
  '/ft-camas-cuidados-criticos',
  '/ft-camas-cirugia',
  '/ft-camas-criticas',
  '/ft-camas-socio-sanitarias',
  '/ft-camas-psiquiatricas',
  '/ft-camas-psiquiatria',
  '/ft-camas-gineco-obstetricas-indiferenciadas',
  '/ft-camas-gineco-obstreticas',
  '/ft-camas-neonatologia',
  '/ft-camas-hospitalizacion-transitoria',
  '/ft-camas-quimioterapia',
  '/ft-camas-medico-quirurgico',
  '/ft-sala-atencion-integral-del-parto',
  '/ft-camas-hospitalizacion-psiquiatria',
  '/ft-cunas-neonatologia',
  '/ft-camas-oncologicas',
  '/ft-sala-toma-de-muestras-de-examenes',
  '/ft-otras-salas-de-procedimientos',
  '/ft-laboratorio-de-anatomia-patologica-y-citologia',

  '/ft-general-indiferenciada',
  '/ft-adulta',
  '/ft-pediatrica',
  '/ft-maternidad',
  '/ft-gineco-obstetrica-maternidad',
  '/ft-dental',
  '/ft-escolar',

  '/ft-salas-de-procedimientos-de-hemodinamia',
  '/ft-sala-procedimientos-endoscopicos',
  '/ft-sala-procedimientos-oftalmologicos',
  '/ft-sala-procedimiento-vascular-periferico',
  '/ft-sala-procedimientos-urologicos',
  '/ft-vacunatorio',
  '/ft-sala-externa-de-toma-de-muestras',
  '/ft-sala-procedimiento-de-rehabilitacion--kinesica',
  '/ft-sala-toma-de-muestras',
  '/ft-salas-de-procedimientos-gineco-obstetricos',
  '/ft-salas-de-consultas',
  '/ft-sala-procedimiento-cardiologia',
  '/ft-salas-de-procedimiento',
  '/ft-sala-procedimientos-odontologicos',
  '/ft-sala-procedimientos-de-cardiologia',
  '/ft-sala-para-yeso',
  '/ft-sala-procedimiento-neurologia',
  '/ft-sala-procedimiento-ginecologia',
  '/ft-sala-procedimiento-otorrino',
  '/ft-sala-procedimiento-respiratorios',

  "/ft-no-invasiva",
  "/ft-invasivas",


  //equipamiento
  '/ft-eq-equipamiento-odontologico',
  '/ft-eq-equipamiento-dialisis',
  '/ft-eq-equipamiento-imagenologia',
  '/ft-eq-equipamiento-laboratorio',

  '/ft-eq-carga-equipamiento',

  '/ft-eq-camas',
  '/ft-eq-camas-medicina',
  '/ft-eq-urgencia',
  '/ft-eq-unidad-recuperacion',
  '/ft-eq-pabellones',
  '/ft-eq-salas-de-procedimientos',
  '/ft-eq-imagenologia',
  '/ft-eq-laboratorio-clinico',
  '/ft-eq-farmacia',
  '/ft-eq-botiquin',
  '/ft-eq-central-de-esterilizacion',
  '/ft-eq-udidad-dialisis',
  '/ft-eq-unidad-donantes',
  '/ft-eq-unidad-medicina-trasnfuncional',
  '/ft-eq-unidad-oncologica-alivio',
  '/ft-eq-radioterapia',
  '/ft-eq-transporte-de-pacientes',
  '/ft-eq-anatomia-patologica',
  '/ft-eq-unidad-medicina-fisica-rehabilitacion',
  '/ft-eq-central-alimentos-sedile',
  '/ft-eq-odontologia',
  '/ft-eq-medicina-nuclear',

  '/ft-eq-equipamiento-general-ambulatorio',
  '/ft-eq-equipamiento-general-hospitalario',
  '/ft-centros-dependientes',
  '/ft-centro-medico-dependiente',
  '/ft-centro-medico-salud',
  '/ft-eq-centro-medico-diagnostico-salud',


  /* -------- */
  '/ft-equipo-de-anatomia-patologica',
  '/ft-equipo-laboratorio-clinico',
  '/ft-equipo-de-farmacia',
  '/ft-recetario-magistral',
  '/ft-equipo-de-dialisis',
  '/ft-sin-datos',
  '/ft-transporte-simple-de-pacientes',
  '/ft-transporte-asistido-de-pacientes',
  '/ft-equipo-de-esterilizacion',
  '/ft-equipo-de-imagenologia',
  '/ft-equipo-unidad-de-quimioterapia',
  '/ft-equipos-de-resucitacion-cardio-pulmonar',
  '/ft-equipo-unidad-de-radioterapia',
  '/ft-equipo-de-umt',
  '/ft-equipo-de-banco-de-sangre',
  '/ft-equipo-de-medicina-nuclear',
  '/ft-atencion-cerrada',

  '/ft-equipo-para-unidad-intensivo-adulto-/pediatrica',
  '/ft-equipo-para-unidad-intermedio-adulto-y-pediatrico',
  '/ft-equipo-pabellon-qx',
  '/ft-equipo-pabellon-de-cx-menor',
  '/ft-equipo-recuperacion',
  '/ft-equipo-mq',
  '/ft-equipo-go',
  '/ft-equipo-neo-intensivo',
  '/ft-equipo-neo-intermedio',
  '/ft-equipo-neo-basica',
  '/ft-equipo-unidad-de-emergencia-adulto-y/o-ped.',
  '/ft-equipo-pabellon-de-hemdinamia',
  '/ft-eq-centro-de-dialisis',
  '/ft-eq-esterilizacion',
  '/ft-dp-carga-masiva',
  '/ft-dp-dotacion-personal',


]
export const urgenciaV = [
  '/urgencia-vital',
  '/urgencia-vital-rut',
  '/urgencia-vital-nombre',
  '/urgencia-vital-fecha',
  '/urgencia-vital-ricarte',
];
export const mediaciones = ['/mediaciones', '/mediacionesReclamos', '/mediacionesPendientes', '/mediacionesAyuda'];
export const fiscalizacion = ['/fiscalizacion'];
export const seguimientoif = [
  '/seguimientoif/asignaciones',
  '/seguimientoif/todos',
  '/seguimientoif/derivaciones',
  '/seguimientoif/mediacion',
  '/seguimientoif/reclamos',
  '/seguimientoif/arbitraje',
  '/seguimientoif/correos',
  '/seguimientoif/ayuda',
];

export const basic = [URL_DEFAULT];
